module.exports = __webpack_public_path__ + "static/media/inflatable-castle.98eca083.png";